<template>
    <div id="login-view">
        <v-card>
            <v-toolbar
                    dark
                    color="secondary"
            >
                <v-toolbar-title>{{ $tc('LogIn', 1) }}</v-toolbar-title>
            </v-toolbar>
            <form
                    id="login_form"
                    @submit.prevent="ensureCsrfTokenAndLogin(userInputs)"
            >
                <v-row>
                    <v-col
                           class="mx-3 mt-3"
                    >
                        <v-text-field
                                v-model="userInputs.username"
                                id="username"
                                :label="$t('Username')"
                                clearable
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                           class="mx-3"
                    >
                        <v-text-field
                                v-model="userInputs.password"
                                type="password"
                                id="password"
                                :label="$t('Password')"
                                clearable
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                            class="mx-3"
                    >
                        <v-text-field
                                v-model="userInputs.verification_code"
                                id="verification_code"
                                :label="$t('VerificationCode')"
                                clearable
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col
                            class="mx-3"
                    >
                        <v-alert
                                v-if="error"
                                type="warning"
                        >
                            {{ loginErrorMessage }}
                        </v-alert>
                    </v-col>
                </v-row>
                <v-progress-linear
                        :active="authenticating"
                        :indeterminate="authenticating"
                ></v-progress-linear>
            </form>
            <v-card-actions>
                <v-btn
                        type="submit"
                        id="login-button"
                        form="login_form"
                        color="primary"
                >
                    Logga in
                    <v-icon right>
                        verified_user
                    </v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script lang="ts">
    import {mapGetters, mapMutations, mapState} from 'vuex';
    import axios from "axios";
    import i18n from "../i18n";

    export default {
        data() {
            return {
                userInputs: {
                    username: '',
                    password: '',
                    verification_code: '',
                },
                loginErrorMessage : i18n.tc('LoginFailed'),
            };
        },
        computed: {
            ...mapState('auth', [
                'error',
                'authenticating',
            ]),
            ...mapGetters('auth', [
                'isAuthenticated',
            ]),
            ...mapGetters('common', [
                'serverURL',
            ]),
        },
        methods: {
            checkForCsrfCookie() {
                return this.getCookie('csrftoken');
            },
            getCookie (name) {  /// Retrieve cookie function
                let cookieValue = null;
                if (document.cookie && document.cookie !== '') {
                    const cookies = document.cookie.split(';');
                    for (let i = 0; i < cookies.length; i++) {
                        const cookie = cookies[i].trim();
                        // Does this cookie string begin with the name we want?
                        if (cookie.substring(0, name.length + 1) === (name + '=')) {
                            cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                            break;
                        }
                    }
                }

                return cookieValue;
            },
            ensureCsrfTokenAndLogin({username, password, verification_code}) {
                this.loginBegin();
                if (!this.checkForCsrfCookie()) {
                    axios
                        .get(
                            this.serverURL + '/set-csrf-cookie/',
                            { withCredentials: true }
                        )
                        .then(response => {
                            if (response.status == 200) {
                                this.doLogin(username
                                    , password
                                    , verification_code
                                );
                            }
                        });
                }
                else {
                    this.doLogin(username
                        , password
                        , verification_code
                    );
                }
            },
            doLogin(username
                , password
                , verification_code
            ) {
                // Reset error message
                this.loginErrorMessage = i18n.tc('LoginFailed');

                axios
                    .post(
                        this.serverURL + '/login/',
                        {
                            username,
                            password,
                            verification_code,
                        },
                    )
                    .then(response => {
                        if (response.status == 200) {
                            this.loginSuccess();
                            this.setUserIsSuperUser(response.data.user_is_super_user);
                            this.$router.replace({ name: 'Home' });
                        }
                        else {
                            this.loginFailure();
                        }
                    })
                    .catch (error => {
                        console.log(error.response.data);
                        if (error.response.status == 400) {
                            if (error.response.data.exceeded_number_of_allowed_attempts === true)
                            {
                                this.loginErrorMessage = i18n.tc('CannotLoginDueToExceededMaximumAttempts')
                            }
                            this.loginFailure();
                        }
                        else if (error.response.status == 403) {
                            this.loginFailure();
                        }
                    });
            },
            ...mapMutations({
                setLoggedIn: 'auth/setLoggedIn',
                loginBegin: 'auth/loginBegin',
                loginFailure: 'auth/loginFailure',
                loginSuccess: 'auth/loginSuccess',
                setUserIsSuperUser: 'auth/setUserIsSuperUser',
            }),
        },
    };
</script>

<style>
    form input {
        display: block
    }
</style>
